import {LayoutComponent} from "../../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {SpajkRiplayComponent} from "./spajk-riplay.component";

const routes: Routes = [
  {
    path: 'spajk-riplay',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: SpajkRiplayComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpajkRiplayRoutingModule { }
